import { render } from "./IconCalendar.vue?vue&type=template&id=37b44aea&scoped=true"
const script = {}

import "./IconCalendar.vue?vue&type=style&index=0&id=37b44aea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b44aea"]])

export default __exports__